import { render, staticRenderFns } from "./TasksCrud.vue?vue&type=template&id=74a946ee&"
import script from "./TasksCrud.vue?vue&type=script&lang=js&"
export * from "./TasksCrud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports